import * as types from '@/constants/mutationTypes'

const state = {
  contactDocs: []
}
const getters = {
  contactDocs: state => state.contactDocs
}
const actions = {
  setContactDocs ({commit}, data) {
    commit(types.SET_CONTACT_DOCS, {data})
  },
  removeContactDoc ({commit}, idRemovedDoc) {
    commit(types.REMOVE_CONTACT_DOC, idRemovedDoc)
  },
  updateContactDoc ({commit}, updatedDocument) {
    commit(types.UPDATE_CONTACT_DOC, document)
  },
}
const mutations = {
  [types.SET_CONTACT_DOCS] (state, {data}) {
    state.contactDocs = data;
  },
  [types.REMOVE_CONTACT_DOC] (state, idRemovedDoc) {
    state.contactDocs = state.contactDocs.filter(doc => doc.id !== idRemovedDoc);
  },
  [types.UPDATE_CONTACT_DOC] (state, updatedDocument) {
    state.contactDocs = state.contactDocs.map(doc => doc.id === updatedDocument.id
      ? {...updatedDocument}
      : doc
    );
  },
}
export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/ContactDocuments/modules/store.js